declare global {
	interface Window {
		__aifcDebuggerEnabled__: boolean | undefined;
	}
}

export function log(message: string, ...args: unknown[]) {
	try {
		if (window.top?.__aifcDebuggerEnabled__) {
			// eslint-disable-next-line no-console
			console.log(`[editor-rovo-bridge]: ${message}`, ...args);
		}
	} catch (e) {
		// Ignore cross origin frame access errors
	}
}
